import React from 'react';

import { css } from 'config/emotionCss';

import { TimePicker } from '.';

const popupClassName = css`
  .ant-picker-panel-layout {
    .ant-picker-content {
      .ant-picker-time-panel-column:not([data-type='hour']) {
        display: none;
      }
    }
  }
`;

/** @type {React.FC<import("antd").TimePickerProps>} */
const HourPicker = props => <TimePicker {...props} classNames={{ popup: { root: popupClassName } }} />;

export default HourPicker;
